import PropTypes from 'prop-types';
import React from 'react';
import JobActions from '../../actions/JobActions';
import SavedJobActions from '../../actions/SavedJobActions';
import { Pager, Form, FormGroup, ControlLabel, Col, FormControl } from 'react-bootstrap';
import PageButton from '../../components/form_components/PageButton.react';
import MatchingSpec from '../../stores/specs/MatchingSpec';
import CurrentOrganizationIdStore from '../../stores/CurrentOrganizationIdStore';
import CurrentRoleStore from '../../stores/CurrentRoleStore';

export default class MatchingStep1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      job: new MatchingSpec(),
      organizationId: CurrentOrganizationIdStore.getState(),
      canSave: CurrentRoleStore.canSaveJobs(),
    };

    this._onChange = this._onChange.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onSave = this.onSave.bind(this);

    this.updateQuery = this.updateField.bind(this, 'query');
    this.updateThreshold = this.updateField.bind(this, 'threshold');
    this.updateOutputTable = this.updateField.bind(this, 'outputTable');
    this.updateOutputSchema = this.updateField.bind(this, 'outputSchema');
    this.updateEnteredName = this.updateField.bind(this, 'enteredName');
  }

  componentDidMount() {
    this.orgIdSubscription = CurrentOrganizationIdStore.addListener(this._onChange);
    this.roleSubscription = CurrentRoleStore.addListener(this._onChange);
  }

  componentWillUnmount() {
    this.orgIdSubscription.remove();
    this.roleSubscription.remove();
  }

  onSave() {
    SavedJobActions.create(this.state.job.jobName,
      this.state.organizationId,
      this.state.job.configJson);
  }

  onComplete() {
    JobActions.submitJob(this.state.job.jobName,
      this.state.organizationId,
      this.state.job.configJson);
    const { router } = this.context;
    router.push('/matching/complete');
  }

  _onChange() {
    this.setState({
      organizationId: CurrentOrganizationIdStore.getState(),
      canSave: CurrentRoleStore.canSave(),
    });
  }

  updateField(field, e) {
    this.setState({ job: this.state.job.set(field, e.target.value) });
  }

  render() {
    return (
      <div>
        <Form horizontal>
          <FormGroup>
            <Col xs={3} componentClass={ControlLabel}>Job Name</Col>
            <Col xs={4}>
              <FormControl
                type='text'
                value={this.state.job.jobName}
                onChange={this.updateEnteredName}
              />
            </Col>
          </FormGroup>
          <h3>What would you like to match?</h3>
          <FormGroup>
            <Col xs={3} componentClass={ControlLabel}>Database Query</Col>
            <Col xs={8}>
              <FormControl
                componentClass='textarea'
                placeholder='select * from table'
                value={this.state.job.query}
                onChange={this.updateQuery}
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col xs={3} componentClass={ControlLabel}>Confidence Threshold (1-100)</Col>
            <Col xs={2}>
              <FormControl
                type='number'
                min='1'
                max='100'
                value={this.state.job.threshold}
                onChange={this.updateThreshold}
              />
            </Col>
          </FormGroup>
          <h3>Output results to:</h3>
          <FormGroup>
            <Col xs={3} componentClass={ControlLabel}>Database Schema</Col>
            <Col xs={8}>
              <FormControl
                type='text'
                value={this.state.job.outputSchema}
                onChange={this.updateOutputSchema}
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col xs={3} componentClass={ControlLabel}>Table Name</Col>
            <Col xs={8}>
              <FormControl
                type='text'
                value={this.state.job.outputTable}
                onChange={this.updateOutputTable}
              />
            </Col>
          </FormGroup>
        </Form>
        <Pager>
          <PageButton
            bsStyle='primary'
            next onSelect={this.onComplete} disabled={!this.state.job.valid}>Submit</PageButton>
          {this.state.canSave &&
            <PageButton
              bsStyle='primary'
              next
              onSelect={this.onSave}
              disabled={!this.state.job.valid}
            >Save
            </PageButton>
          }
        </Pager>
      </div>
    );
  }
}

MatchingStep1.contextTypes = {
  router: PropTypes.object
};

MatchingStep1.propTypes = {
  organizationId: PropTypes.number,
  job: PropTypes.object,
  canSave: PropTypes.bool
};
